import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';

import HomePageBG from '../assets/HomepageBG.jpg';
import { ROUTES } from '../constants/routes';

import { NavbarLoading } from './NavbarLoading';

const PublicRoute = ({ children }) => {
  const { user, isAuthenticated, loading, initialAuthCheckDone } = useSelector(
    (state) => state.auth
  );

  if (loading && !initialAuthCheckDone) {
    return (
      <div>
        <NavbarLoading src={HomePageBG} pageName={'Sustainable Land Initiative'} />
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
          <MoonLoader color="#000" size={50} />
        </div>
      </div>
    );
  }

  if (isAuthenticated && initialAuthCheckDone) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return children;
};

export { PublicRoute };
